import { render, staticRenderFns } from "./AccountDeletionRequestsView.vue?vue&type=template&id=1c0a7927&scoped=true&"
import script from "./AccountDeletionRequestsView.vue?vue&type=script&lang=js&"
export * from "./AccountDeletionRequestsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0a7927",
  null
  
)

export default component.exports